<template>
  <article class="p-question__response">
    <strong>{{response.created_user.name}}</strong>
    {{' '}}{{response.description}}
    <div class="p-question__response__date">
      <p>
        <icon name="clock"/>
        {{ ' ' }}
        <time
          :datetime="$dayjs(response.created_time).format('YYYY-MM-DD')"
        >{{$dayjs(response.created_time).fromNow()}}</time>
      </p>
    </div>
  </article>
</template>

<script>
export default {
  name: "QuestionResponse",
  props: {
    response: {
      type: Object,
      default: () => {}
    }
  }
};
</script>

<style lang="scss" scoped>
.p-question__response {
  background: $colour-nhs-core-white;
  padding: 20px;
  margin-bottom: 10px;
  border: 1px solid $colour-nhs-pale-grey;

  strong {
    font-family: $font-frutiger-bold;
    color: $colour-nhs-core-blue;
  }

  &__date {
    font-size: 14px;
    color: $colour-nhs-mid-grey;
    p {
      display: inline-flex;
      align-items: center;
      margin-bottom: 0;
    }

    svg {
      fill: $colour-nhs-mid-grey;
      stroke: $colour-nhs-mid-grey;
      margin-right: 5px;
    }
  }
}
</style>